import { useState } from 'react';
import { useUserCreditsQuery } from '@lingoda/graphql';
import { useSelector } from '@lingoda/hooks';
import { trans } from '@lingoda/i18n';
import { showToast } from '@lingoda/toasts';
import { hasSubscriptionSelector } from '@lingoda/subscriptions';
import { Popover, Typography } from '@lingoda/ui';
import { styled } from '@lingoda/ui/theme';
import { studentCreditsSelector } from '@lingoda/students';
import { StudentCreditsButton, StudentCreditsContent } from '../CreditsTags';
import { StudentCreditsInfo } from './StudentCreditsInfo';

const StyledPopover = styled(Popover)(({ theme }) => ({
    '& .MuiPopover-paper': {
        width: 310,
        marginTop: 11,
        paddingBottom: theme.spacing(2),
    },
}));

export const CreditsStore = () => {
    const { data, loading } = useUserCreditsQuery({
        fetchPolicy: 'cache-and-network',
        onError: (error) => showToast('error', error.message),
    });

    const hasSubscription = useSelector(hasSubscriptionSelector);
    const { group, individual } = useSelector(studentCreditsSelector);
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const isOpen = !!anchorEl;

    return (
        <>
            <StudentCreditsButton onClick={handleClick}>
                <StudentCreditsContent
                    groupCredits={group}
                    individualCredits={individual}
                    showZeroClasses
                />
            </StudentCreditsButton>
            <StyledPopover
                anchorEl={anchorEl}
                open={isOpen}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Typography variant="subtitle1" px={2} my={2}>
                    {trans('my-class-credits', {}, 'student-common')}
                </Typography>
                <StudentCreditsInfo
                    isLoading={loading}
                    onCTAClick={handleClose}
                    hasSubscription={hasSubscription}
                    {...data?.studentCreditsInfo}
                />
            </StyledPopover>
        </>
    );
};
